export const issues = [
  {
    option: 'purchase',
    text: 'I have a question about a purchase I want to make',
  },
  {
    option: 'purchased',
    text: 'I have a question about a purchase I made on Luxury Escapes',
  },
  {
    option: 'somethingElse',
    text: 'I have a question about something else',
  },
]

export const subIssues = {
  purchase: [
    {
      option: 'bookingAssistance',
      text: 'Booking Assistance',
    },
    {
      option: 'quoteRequest',
      text: 'Quote Request',
    },
  ],
  purchased: [
    {
      option: 'changeBooking',
      text: 'Change Booking',
    },
    {
      option: 'cancelBooking',
      text: 'Cancel Booking',
    },
    {
      option: 'generalEnquiries',
      text: 'General Enquiries',
    },
    {
      option: 'complaint',
      text: 'Complaint',
    },
    {
      option: 'positiveFeedback',
      text: 'Positive Feedback',
    },
  ],
  somethingElse: [
    {
      option: 'changeDetails',
      text: 'I want to change my details (name, contact number, email address)',
    },
    {
      option: 'forgotPassword',
      text: 'I have forgotten my password',
    },
    {
      option: 'leCredits',
      text: 'I have a question about my Luxury Escapes credits',
    },
    {
      option: 'unsubscribe',
      text: 'I want to unsubscribe from Luxury Escapes emails',
    },
    {
      option: 'changeSubscription',
      text: 'I want to change my email subscription frequency',
    },
    {
      option: 'otherQuestion',
      text: 'I have a question that you guys have not thought of yet!',
    },
  ],
}
